/* ------------------------------------------------------------------------ */
/*		File: cmpCard_545.tsx                                               */
/*		Description: Component Implementation                               */
/*		Project: iSymWebSchool											    */
/*		Author: ISym Global Solutions Limited                               */
/*		Version: 1.0													    */
/* ------------------------------------------------------------------------ */


import React from "react";
import { CardProp } from "./cmpCard_545.d";
import "./cmpCard_545_video.css"
import video from "../../img/promotional.mp4";
import Button from "../GenericComponents/Button";
import { colorType } from "../GenericComponents/generic.d";
import { useNavigate } from "react-router-dom";
import { getImage } from "../GenericComponents/functions";

/* ------------------------------------------------------------------------ */

const Card_545_video: React.FC<CardProp> = ({card}: CardProp) => {
    const navigate = useNavigate();

    return (
        <div className="card_545_video video">
            <div className={`card_545_video_img_container`}>
                {card!.src !== null && card!.src!.includes(".mp4") ? (
                    <video
                        className='w-full lg:h-full md:h-full h-full object-fill'
                        muted
                        autoPlay
                        loop
                        playsInline
                        controls
                    >
                        <source src={video} type="video/mp4" />
                    </video>
                ) : (
                    <img className="card_545_video_img" src={getImage(card?.src)} alt="" />
                )}            

            </div>
            <div className={`float_left_container ${card.description == null ? "float_left_viewport" : ""}`}>
                <div className="card_545_video_details">
                    {/* <div className="card_545_video_first_row">
                        {card.label !== null
                        ?
                        <div className="card_545_video_title">
                            <div className="card_545_video_mini_square"></div>
                            <p className="card_545_video_first_row_details">{card?.label}</p>
                        </div>
                        : 
                        <></>
                        }

                    </div> */}
                    <p className="card_545_video_second_row">{card?.description}</p>

                </div>
                {/* {card.button_label !== null
                ?
                <div className="button">
                    <Button 
                    classProp={"yellow-button"}
                    label={card?.button_label}
                    hasIcon={false}
                    size={"small"}
                    textColor={colorType.BLUE}
                    onClick={() => navigate(`${card?.navigateTo}`)}
                    />
                </div>
                :
                <></>} */}

            </div>
        </div>
    );
};
export default Card_545_video; 